import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";

const ProblemSection = () => {
  const { lang, t } = useI18n();

  return (
    <section id="why" className="py-16 md:py-20 bg-background">
      <div className="container mx-auto px-6 max-w-[960px]">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="section-label mb-3">{t.problem.label[lang]}</div>
          <h2 className="font-display text-3xl md:text-5xl text-foreground mb-5 leading-[1.1]">
            {t.problem.h2[lang]}
          </h2>
          <p className="font-light text-[15px] leading-[1.7] text-brand-text max-w-[680px]">
            {t.problem.p1[lang]}
          </p>
          <p className="font-light text-[15px] leading-[1.7] text-brand-text max-w-[680px] mt-4">
            {t.problem.p2[lang]}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ProblemSection;
